// @flow
import React from 'react';

type Props = {
	match: Object
}

const LeagueHistory = (props: Props) => {
	const { match } = props;
	return (
		<div>
			<h1>League History - league_id {match.params.league_id}</h1>
		</div>
	);
};

export default LeagueHistory;


// WEBPACK FOOTER //
// ./src/pages/league/LeagueHistory.js